<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
					<span class="navigation-title">{{machineType.name}}</span>
					<div class="navigation-right">
						<DotMenu alignment="right">
							<DotMenuItem @clicked="save">{{$t('save')}}</DotMenuItem>
							<DotMenuSeparator/>
							<DotMenuItem @clicked="remove" class="delete">{{$t('delete')}}</DotMenuItem>
						</DotMenu>
					</div>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prevent="save" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<!-- <span class="title">{{$t('basic-information')}}</span> -->
								<div class="field-inner">
									<label for="name">{{$t('name')}}*</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="newMachineType.name" id="name" required>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
					<div class="container">
						<div class="content">
							<button class="">{{$t('save')}}</button>
						</div>
					</div>
				</form>
			</section>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import DotMenu from '@/components/DotMenu/DotMenu.vue'
import DotMenuItem from '@/components/DotMenu/DotMenuItem.vue'
import DotMenuSeparator from '@/components/DotMenu/DotMenuSeparator.vue'

export default {
	data() {
		return {
			newMachineType: {
				id: '',
				name: '',
			},
			machineType: {},
			saveError: false,
		}
	},
	components: {
		DotMenu,
		DotMenuItem,
		DotMenuSeparator,
	},
	created() {
		let self = this;
		axios.get(`/machine-types/${self.$route.params.id}`)
		.then((response) => {
			self.machineType = {...response.data.response.machineType};
			self.newMachineType = {...response.data.response.machineType};
		})
		.catch((err) => {
			self.$router.go(-1);
		});
	},
	methods: {
		save() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}

			this.saveError = false;

			if (JSON.stringify(this.machineType) === JSON.stringify(this.newMachineType)) {
				this.$snack.success(this.$t('nothing-to-save'));
				return;
			}

			if (!this.newMachineType.name) {
				this.saveError = true;
				this.$snack.danger(this.$t('compile-all-required-fields'));
			}

			if (!this.saveError) {
				let params = new URLSearchParams();

				params.append('name', this.newMachineType.name);

				let self = this;
				axios.put(`/machine-types/${self.$route.params.id}`, params)
				.then((response) => {
					self.$snack.success(self.$t('saved-successfully'));
					self.machineType = {...self.newMachineType};
				})
				.catch((err) => {
					let resp = err.response;
					if (resp.data.response && resp.data.response.duplicate) {
						switch (resp.data.response.duplicate) {
							case 'name':
								self.$snack.danger(self.$t('duplicate-name-error'));
								break;
						}
					} else {
						self.$snack.danger(self.$t('save-error'));
					}
					self.saveError = true;
					if (navigator.vibrate){
						navigator.vibrate([500]);
					}
				});
			}
		},
		remove() {
			let self = this;
			let onConfirm = (buttonIndex) => {
				if (buttonIndex == 1) {
					axios.delete(`/machine-types/${self.$route.params.id}`)
					.then((response) => {
						self.$snack.success(self.$tc('machine-type-deleted-successfully', 1, {count: 1}));
						self.$router.go(-1);
					})
					.catch((err) => {
						let resp = err.response;
						self.$snack.danger(self.$t('delete-error'));

						if (navigator.vibrate){
							navigator.vibrate([500]);
						}
					});
				}
			}
			let message = self.$tc('delete-machine-type-confirm', 1, {count: 1});
			if (navigator.notification) {
				navigator.notification.confirm(
					message,	// message
					onConfirm,						// callback to invoke with index of button pressed
					this.$t('delete-machine-type'),			// title
					[this.$t('confirm'),
					this.$t('cancel')]	// buttonLabels
				);
			} else {
				if (confirm(message)) onConfirm(1);
			}
		},
	}
}
</script>